import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.743,
	height: 10.296,
	viewBox: "0 0 13.743 10.296",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6864",
		"data-name": "Path 6864",
		d: "M8.059,14.353,5.193,11.487a.811.811,0,1,0-1.146,1.146l3.431,3.431a.815.815,0,0,0,1.154,0l8.679-8.671a.811.811,0,0,0-1.146-1.146Z",
		transform: "translate(-3.807 -6.008)"
	})
});
export { SvgTick as ReactComponent };
